// src/components/doctorsJournal/JournalUnlock.js
import React, { useState } from 'react';
import { Unlock, AlertCircle, Loader2 } from 'lucide-react';

export const JournalUnlock = ({ isOpen, onUnlock, onCancel }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [attempts, setAttempts] = useState(0);
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const success = await onUnlock(password);

      if (!success) {
        setAttempts(prev => prev + 1);
        setError('סיסמה שגויה');
        setPassword('');
      } else {
        setPassword('');
        setAttempts(0);
      }
    } catch (error) {
      setError('שגיאה בבדיקת הסיסמה');
      console.error('Unlock error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="relative w-full max-w-md mx-4">
        <div className="bg-white rounded-2xl shadow-2xl border border-pink-100 overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-br from-pink-50 to-purple-50 px-6 py-8 text-center border-b border-pink-100">
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-purple-500 rounded-full flex items-center justify-center shadow-lg">
                <Unlock className="w-8 h-8 text-white" />
              </div>
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">פתיחת יומן רופא</h2>
            <p className="text-sm text-gray-600">הזן סיסמה לצפייה ברשומות מוצפנות</p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="p-6 space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                סיסמת יומן
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError('');
                }}
                disabled={loading}
                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all"
                placeholder="הזן סיסמה"
                autoFocus
                required
              />
            </div>

            {/* Error Message */}
            {error && (
              <div className="p-3 bg-red-50 border border-red-200 rounded-xl flex items-center gap-2">
                <AlertCircle className="w-4 h-4 text-red-600" />
                <p className="text-sm text-red-800">{error}</p>
              </div>
            )}

            {/* Attempts Warning */}
            {attempts >= 3 && (
              <div className="p-3 bg-amber-50 border border-amber-200 rounded-xl">
                <p className="text-sm text-amber-800 text-center">
                  ניסיונות רבים מדי. אנא המתן רגע
                </p>
              </div>
            )}

            {/* Buttons */}
            <div className="flex gap-3">
              <button
                type="button"
                onClick={onCancel}
                disabled={loading}
                className="flex-1 py-3 border border-gray-300 text-gray-700 font-semibold rounded-xl hover:bg-gray-50 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              >
                ביטול
              </button>
              <button
                type="submit"
                disabled={loading || !password}
                className="flex-1 py-3 bg-gradient-to-l from-purple-500 to-pink-500 text-white font-semibold rounded-xl hover:from-purple-600 hover:to-pink-600 transition-all shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:from-purple-500 disabled:hover:to-pink-500 flex items-center justify-center gap-2"
              >
                {loading ? (
                  <>
                    <Loader2 className="w-4 h-4 animate-spin" />
                    <span>בודק...</span>
                  </>
                ) : (
                  'פתח יומן'
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};